import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-error-400',
  templateUrl: './error-400.component.html',
  styleUrls: ['./error-400.component.scss'],
  standalone: true,

  imports: [Button, RouterLink]
})
export class Error400Component {
  constructor() {}
}
